import React, { createContext } from "react";
import PropTypes from "prop-types";
import { MSP_BRAND_DRUVA, MSP_BRAND_DELL } from "../../lib/mspBrands";

export const OrionContext = createContext();
class OrionProvider extends React.Component {
  componentDidMount() {
    const { brand } = this.props;
    document.body.classList.add(`oui-msp-provider-${brand.toLowerCase()}`);
  }

  componentWillUnmount() {
    const { brand } = this.props;
    document.body.classList.add(`oui-msp-provider-${brand.toLowerCase()}`);
  }

  isDellApplication = () => {
    const { brand } = this.props;
    return brand === MSP_BRAND_DELL;
  };

  render() {
    const { brand, children, dellDoubleHeader } = this.props;

    return (
      <OrionContext.Provider
        value={{
          brand,
          dellDoubleHeader,
          isDellApplication: this.isDellApplication
        }}
      >
        {children}
      </OrionContext.Provider>
    );
  }
}

OrionProvider.propTypes = {
  brand: PropTypes.string,
  dellDoubleHeader: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

OrionProvider.defaultProps = {
  brand: MSP_BRAND_DRUVA
};

export default OrionProvider;
